<template>
  <IQOS title="Скидка на первый заказ клиента" :enabled="promotion.enabled">
    <p class="iqos-comment mt-16" v-if="!promotion.enabled">
        Вы можете включить скидку на первый заказ клиента по системам
    </p>

    <div class="gap-row-xs mt-16" v-if="promotion.enabled">
        <div class="gap-row-1xs w-100">
            <div class="iqos-comment w-100">
                Размер скидки:
            </div>
            <BaseUnitInput 
                type="number" 
                @blur="onSave"
                :valid="promotion.size && promotion.size >= 0"
                v-model.number="promotion.size"
                placeholder="0"
                fullWidth
                unitPlaceholder="%"/>
        </div>
        <div class="gap-row-1xs">
            <div class="iqos-comment w-100">
                Системы:
            </div>
            <IQOSModeToggle v-if="cafe.modes.inside" mode="inside" v-model="promotion.modes.inside"/>
            <IQOSModeToggle v-if="cafe.modes.preorder" mode="preorder" v-model="promotion.modes.preorder"/>
            <IQOSModeToggle v-if="cafe.modes.delivery" mode="delivery" v-model="promotion.modes.delivery"/>
        </div>
    </div>

    <template #actions>
        <IQOSToggle 
            v-model="promotion.enabled"/>
    </template>
  </IQOS>
</template>

<script>

export default {
    data() {
        return {
            promotion: {
                enabled: false,
                size: 0,
                modes: {
                    inside: false,
                    preorder: false,
                    delivery: false
                }
            },
            loaded: false
        }
    },
    watch: {
        'promotion.modes': {
            deep: true,
            handler() {
                if (this.loaded) this.onSave();
            }
        },
        'promotion.enabled'() {
                if (this.loaded) this.onSave();
        }
    },
    methods: {
        onSave() {
            this.$store.commit('patchCafeGeneralData', {
                first_order_discount: this.promotion
            });
            this.$store.dispatch('saveCafe');
        }
    },
    computed: {
        cafe() {
            return this.$store.state.cafe;
        }
    },
    mounted() {
        this.promotion = {
            ...this.cafe.first_order_discount
        };
        this.loaded = true;
    }
}
</script>

<style>

</style>